import store from '@/store'

export const REPORT_ONBOARDING_TOURS_ORDER = [
  { skip_key: 'reportOnboardingSkipped', name: 'reportIntroV2', needAuth: false },
]

export const startOnboardingTour = ({ vm, tourName }) => {
  if (!vm.$tours[tourName]) return
  const tour = vm.$tours[tourName]
  if (tour.isRunning) return
  if (tour.steps.length === 0) return

  const firstStep = vm.$tours[tourName].steps[0]

  if (firstStep.target && document.querySelector(firstStep.target)) {
    vm.$tours[tourName].start()
  } else {
    vm.$tours[tourName].stop()
  }
}
export const filterSteps = ({ vm }) => {
  vm.steps = vm.steps.filter(step => {
    if (!step.target) return true
    try {
      return !!document.querySelector(step.target)
    } catch (e) {
      return false
    }
  })
}
export const initOnboardingToLocalStorage = () => {
  const onboarding = localStorage.getItem('onboarding')
  if (!onboarding) {
    const defaultState = getDefaultOnboardingState()
    localStorage.setItem('onboarding', JSON.stringify(defaultState))
  }
}

export const getDefaultOnboardingState = () =>
  Object.fromEntries(
    REPORT_ONBOARDING_TOURS_ORDER.map(tour => [tour.skip_key, false]),
  )

export const startReportOnboardingTours = ({ vm }) => {
  if (window.__PRERENDER_INJECTED) return;

  const raw = localStorage.getItem('onboarding');
  const onboarding = (raw && raw !== "undefined") ? JSON.parse(raw) : {};

  const nextTour = REPORT_ONBOARDING_TOURS_ORDER.find(
    ({ skip_key, name, needAuth }) => {
      if (onboarding[skip_key] || (needAuth && !store.getters['user/isLogin']))
        return false

      const firstStep = vm.$tours[name]?.steps[0]
      if (firstStep?.target && document.querySelector(firstStep.target))
        return true
    },
  )

  if (nextTour) {
    startOnboardingTour({ vm, tourName: nextTour.name })
  }
}
export const onStopReportOnboardingTour = async ({ vm, tourName }) => {
  const tour = REPORT_ONBOARDING_TOURS_ORDER.find(
    ({ name }) => name === tourName,
  )

  if (!tour) return

  const onboarding = localStorage.getItem('onboarding')
  localStorage.setItem(
    'onboarding',
    JSON.stringify({
      ...JSON.parse(onboarding || '{}'),
      [tour.skip_key]: true,
    }),
  )

  await syncOnboardingState({
    remote: store.getters['user/getOnboardingParams'],
  })

  startReportOnboardingTours({ vm })
}

export const syncOnboardingState = async ({ remote }) => {
  if (window.__PRERENDER_INJECTED) return;

  const raw = localStorage.getItem('onboarding');
  const local = (raw && raw !== "undefined") ? JSON.parse(raw) : {};

  const merged = {}

  for (const { skip_key } of REPORT_ONBOARDING_TOURS_ORDER) {
    merged[skip_key] = Boolean(local?.[skip_key] || remote?.[skip_key])
  }

  localStorage.setItem('onboarding', JSON.stringify(merged))

  const needUpdate = REPORT_ONBOARDING_TOURS_ORDER.some(
    ({ skip_key }) => merged[skip_key] !== remote?.[skip_key],
  )

  if (!store.getters['user/isLogin']) return

  if (needUpdate) {
    try {
      await store.dispatch('user/updateOnboardingUserParams', { ...merged })
    } catch (error) {
      console.error('Error updating onboarding params:', error)
    }
  }
}

export const deleteOnboardingState = async () => {
  localStorage.removeItem('onboarding')

  await store.dispatch('user/updateOnboardingUserParams', {
    reportOnboardingSkipped: false,
  })
}

export const stopAllTours = (vm) => {
  if (!vm.$tours) return
  Object.values(vm.$tours).forEach((tour) => {
    if (tour.isRunning) {
      tour.stop()
    }
  })
}
